import {appendQueryString} from "@pg-mono/request";
import {rpAppLink} from "@pg-mono/rp-routes";

import {IOfferListUrlBuildResult} from "./types/IOfferListUrlStrategy";
import {appendCanonicalQueryString} from "./canonical_query";
import {IOfferListUrlInput} from "./offer_list_url_values";

export interface IOfferListUrlLinks {
    listFriendly: (params: {friendlySlug: string}) => string;
    listFriendlySubFilter: (params: {friendlySlug: string; offerListSubFilter: string}) => string;
    listFriendlyAbroad: (params: {friendlySlug: string; country: string; abroadRegionSlug?: string}) => string;
}

const defaultLinks: IOfferListUrlLinks = {
    listFriendly: rpAppLink.offer.listFriendly,
    listFriendlySubFilter: ({friendlySlug, offerListSubFilter}) => rpAppLink.offer.listFriendlySubFilterGeneral({friendlySlug, offerListSubFilter}),
    listFriendlyAbroad: ({friendlySlug, country, abroadRegionSlug}) => rpAppLink.offer.listFriendlyAbroad({friendlySlug, country, abroadRegionSlug})
};

export const appendOfferListSearch = (url: string, query: IOfferListUrlInput, canonicalizeQuery: boolean): string => {
    if (canonicalizeQuery) {
        return appendCanonicalQueryString(url, query);
    }

    return appendQueryString(url, query);
};

export const composeOfferListUrl = (built: IOfferListUrlBuildResult, links?: Partial<IOfferListUrlLinks>): string => {
    const resolvedLinks = {...defaultLinks, ...links};
    const path = resolveOfferListPath(built, resolvedLinks);

    return appendOfferListSearch(path, built.query, built.canonicalizeQuery);
};

export const resolveOfferListPath = (built: IOfferListUrlBuildResult, links: IOfferListUrlLinks = defaultLinks): string => {
    if (built.isAbroad) {
        return links.listFriendlyAbroad({
            friendlySlug: built.friendlySlug,
            country: built.countrySlug || "",
            abroadRegionSlug: built.abroadRegionSlug
        });
    }

    if (built.offerListSubFilterSlug) {
        return links.listFriendlySubFilter({
            friendlySlug: built.friendlySlug,
            offerListSubFilter: built.offerListSubFilterSlug
        });
    }

    return links.listFriendly({friendlySlug: built.friendlySlug});
};

export const normalizeOfferListPath = (path: string): string => {
    const pathname = path.split("?")[0].split("#")[0];

    if (pathname.length > 1 && !pathname.endsWith("/")) {
        return `${pathname}/`;
    }

    return pathname;
};
import {appendQueryString} from "@pg-mono/request";
import {rpAppLink} from "@pg-mono/rp-routes";

import {IOfferListUrlBuildResult} from "./types/IOfferListUrlStrategy";
import {appendCanonicalQueryString} from "./canonical_query";
import {IOfferListUrlInput} from "./offer_list_url_values";

export interface IOfferListUrlLinks {
    listFriendly: (params: {friendlySlug: string}) => string;
    listFriendlySubFilter: (params: {friendlySlug: string; offerListSubFilter: string}) => string;
    listFriendlyAbroad: (params: {friendlySlug: string; country: string; abroadRegionSlug?: string}) => string;
}

const defaultLinks: IOfferListUrlLinks = {
    listFriendly: rpAppLink.offer.listFriendly,
    listFriendlySubFilter: ({friendlySlug, offerListSubFilter}) => rpAppLink.offer.listFriendlySubFilterGeneral({friendlySlug, offerListSubFilter}),
    listFriendlyAbroad: ({friendlySlug, country, abroadRegionSlug}) => rpAppLink.offer.listFriendlyAbroad({friendlySlug, country, abroadRegionSlug})
};

export const appendOfferListSearch = (url: string, query: IOfferListUrlInput, canonicalizeQuery: boolean): string => {
    if (canonicalizeQuery) {
        return appendCanonicalQueryString(url, query);
    }

    return appendQueryString(url, query);
};

export const composeOfferListUrl = (built: IOfferListUrlBuildResult, links?: Partial<IOfferListUrlLinks>): string => {
    const resolvedLinks = {...defaultLinks, ...links};
    const path = resolveOfferListPath(built, resolvedLinks);

    return appendOfferListSearch(path, built.query, built.canonicalizeQuery);
};

export const resolveOfferListPath = (built: IOfferListUrlBuildResult, links: IOfferListUrlLinks = defaultLinks): string => {
    if (built.isAbroad) {
        return links.listFriendlyAbroad({
            friendlySlug: built.friendlySlug,
            country: built.countrySlug || "",
            abroadRegionSlug: built.abroadRegionSlug
        });
    }

    if (built.offerListSubFilterSlug) {
        return links.listFriendlySubFilter({
            friendlySlug: built.friendlySlug,
            offerListSubFilter: built.offerListSubFilterSlug
        });
    }

    return links.listFriendly({friendlySlug: built.friendlySlug});
};

export const normalizeOfferListPath = (path: string): string => {
    const pathname = path.split("?")[0].split("#")[0];

    if (pathname.length > 1 && !pathname.endsWith("/")) {
        return `${pathname}/`;
    }

    return pathname;
};
